import { useEffect, useState } from "react";
import PlanListItem from "./components/PlanListItem";
import "./InterventionPlan.css";
import PaginationComponent from "../../components/PaginationComponent";
import PlanModal from "./modal/PlanModal";
import withRoleBased from "../../utils/Functions/withRoleBased";
import useCategoryList from "../../utils/CustomHooks/useCategoryList";
import useInterventionList from "../../utils/CustomHooks/useInterventionList";
import usePlanList from "../../utils/CustomHooks/usePlanList";
import useScreenerList from "../../utils/CustomHooks/useScreenerList";
function Index({ access = {} }) {
  const [count, setCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const { planList, loading, getPlanList } = usePlanList("");
  const { categoryList, getCategoryList } = useCategoryList("");
  const { interventionList, getInterventionList } = useInterventionList();
  const { screenerList, getScreenerList } = useScreenerList("");
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  useEffect(() => {
    getCategoryList({ supported_content_types: ["PLAN"] });
    getInterventionList({ published: true }, false);
    getScreenerList({ published: true }, false);
  }, []);

  useEffect(() => {
    let req = {};
    if (search) req.plan_name = search;
    getPlanList(req);
  }, [count]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(planList.length / pageSize);

  const onSearch = () => {
    setCurrentPage(0)
    setCount((x) => x + 1);
    setIsSearch(search ? true : false);
  };

  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row ">
          <div className="col-md-6 mb-3">
            <h1 className="page-title"> Plans </h1>
          </div>

          <div className="col-md-6 mb-3 d-flex justify-content-md-end">
            {access.canCreate && (
              <button
                type="submit"
                className="btn btn-outline-success"
                onClick={() => setIsOpen(true)}
              >
                Create Plan
              </button>
            )}
          </div>

          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive ">
              <table className="table domain-table  table-borderless ">
                <thead>
                  <tr className=" ">
                    {access.isAdmin && <td className=""></td>}
                    <td className="">Name</td>
                    <td className="">Category</td>
                    {/* <td className="">Intervention</td> */}
                    <td className="">Sub Domain</td>
                    <td className="">Status</td>
                    <td className="">Action</td>
                  </tr>
                </thead>
                <tbody>
                  {!loading && planList.length > 0 ? (
                    planList
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((x, i) => (
                        <PlanListItem
                          item={x}
                          key={i}
                          index={i}
                          refresh={() => {
                            setSearch("");
                            setCount((x) => x + 1);
                          }}
                          access={access}
                          categoryList={categoryList}
                          interventionList={interventionList}
                          screenerList={screenerList}
                        />
                      ))
                  ) : (
                    <tr>
                      <td className="text-center font-weight-bold" colSpan="7">
                        {loading ? "Loading..." : "No Data Found"}
                      </td>
                    </tr>
                  )}
                  {/* <tr>
                    <td className="col-sm-2">Plan1</td>
                    <td>Stress </td>
                    <td> Plan Game</td>
                    <td> Name1 Date & Time</td>
                    <td>Name1 Date & Time </td>
                    <td>Activated</td>
                    <td>
                      <a className="text-deceration-none s"> Show Details</a>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {planList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
      </div>
      <PlanModal
        isOpen={isOpen}
        setOpen={() => setIsOpen(false)}
        refresh={() => {
          setSearch("");
          setCount((x) => x + 1);
        }}
        categoryList={categoryList}
        interventionList={interventionList}
        screenerList={screenerList}
        isFirst={true}
      />
    </main>
  );
}

export default withRoleBased(Index, "therapy");
